import { render, staticRenderFns } from "./DeviceAttributeTab.vue?vue&type=template&id=31b7956e"
import script from "./DeviceAttributeTab.vue?vue&type=script&lang=js"
export * from "./DeviceAttributeTab.vue?vue&type=script&lang=js"
import style0 from "./DeviceAttributeTab.vue?vue&type=style&index=0&id=31b7956e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports